import React, { Suspense } from 'react';
import { WWW_ORIGIN } from '../../config';
import { lazyWithRetries } from '../../utils/shimport';

const NavigationFooterURL = `${WWW_ORIGIN}/quoting/components/customer-top-nav/microcomponents/navigation-footer.mjs`;
const LazyNavigationFooter = lazyWithRetries(NavigationFooterURL);

const NavigationFooter = () => {
  return (
    <Suspense fallback={<></>}>
      <LazyNavigationFooter wwwBaseUrl={WWW_ORIGIN} />
    </Suspense>
  );
};

export default NavigationFooter;
